import { render } from "./ModalRemovePrintTemplate.vue?vue&type=template&id=2d97eca4"
import script from "./ModalRemovePrintTemplate.vue?vue&type=script&lang=js"
export * from "./ModalRemovePrintTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__